(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function applyCtaText(wrap) {
      if (wrap.dataset.ctaTextBound === 'true') return;

      var availableText = wrap.dataset.ctaText;
      var soldOutText = wrap.dataset.ctaSoldOutText;
      if (!availableText && !soldOutText) return;

      var btn = wrap.querySelector('.add-to-cart');
      var textEl = wrap.querySelector('[data-add-to-cart-text]');
      if (!btn || !textEl) return;

      wrap.dataset.ctaTextBound = 'true';

      if (availableText) {
        textEl.dataset.defaultText = availableText;
      }

      function isSoldOut() {
        return btn.disabled || btn.hasAttribute('disabled') || btn.classList.contains('disabled');
      }

      function refresh() {
        var target = isSoldOut() ? (soldOutText || textEl.textContent) : (availableText || textEl.textContent);
        if (target && textEl.textContent.trim() !== target) {
          textEl.textContent = target;
        }
      }

      refresh();

      new MutationObserver(refresh).observe(textEl, { childList: true, characterData: true, subtree: true });
      new MutationObserver(refresh).observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }

    function initCtaText() {
      document.querySelectorAll('.product-block--buy-buttons[data-cta-text], .product-block--buy-buttons[data-cta-sold-out-text]').forEach(applyCtaText);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCtaText);
    } else {
      initCtaText();
    }
    document.addEventListener('shopify:section:load', initCtaText);

    function customBundleImageUrl(src, width) {
      var separator = src.indexOf('?') === -1 ? '?' : '&';
      return src + separator + 'width=' + width;
    }

    function updateCustomBundleImage(img, imageData) {
      if (!imageData || !imageData.src) return;

      var widths = [400, 600, 800, 1000, 1200, 1600];
      var srcset = widths
        .map(function (width) {
          return customBundleImageUrl(imageData.src, width) + ' ' + width + 'w';
        })
        .join(', ');

      img.src = customBundleImageUrl(imageData.src, 1600);
      img.setAttribute('srcset', srcset);

      if (imageData.alt) {
        img.alt = imageData.alt;
      }
    }

    function bindCustomBundleVariantImage(img) {
      if (img.dataset.variantImageBound === 'true') return;

      var section = img.closest('.custom-bundle');
      var productContainer = section && section.querySelector('[data-section-type="product"]');
      if (!productContainer) return;

      img.dataset.variantImageBound = 'true';

      var fallbackSrc = img.getAttribute('data-fallback-src');
      var fallbackSrcset = img.getAttribute('data-fallback-srcset');
      var fallbackAlt = img.getAttribute('data-fallback-alt');

      productContainer.addEventListener('variantChange', function (evt) {
        var variant = evt.detail && evt.detail.variant;
        if (!variant) return;

        if (variant.featured_image && variant.featured_image.src) {
          updateCustomBundleImage(img, variant.featured_image);
          return;
        }

        // No image connected to this variant: fall back to the image set in the theme customizer.
        if (fallbackSrc) {
          img.src = fallbackSrc;
          if (fallbackSrcset) {
            img.setAttribute('srcset', fallbackSrcset);
          } else {
            img.removeAttribute('srcset');
          }
          if (fallbackAlt) {
            img.alt = fallbackAlt;
          }
        }
      });
    }

    function initCustomBundleVariantImages() {
      document.querySelectorAll('.custom-bundle [data-custom-bundle-image][data-use-variant-image="true"]').forEach(bindCustomBundleVariantImage);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCustomBundleVariantImages);
    } else {
      initCustomBundleVariantImages();
    }
    document.addEventListener('shopify:section:load', initCustomBundleVariantImages);

    if (window.__customBundleOffsetBound) return;
    window.__customBundleOffsetBound = true;

    function setHeaderOffset() {
      var header = document.getElementById('SiteHeader') || document.querySelector('.header-wrapper, .site-header');
      var height = header ? header.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--custom-bundle-header-offset', height + 'px');
    }

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        setHeaderOffset();
        ticking = false;
      });
    }

    setHeaderOffset();
    window.addEventListener('load', setHeaderOffset);
    window.addEventListener('resize', onScrollOrResize);
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-columns"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    class FaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
      }

      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;

        this.singleOpen = this.dataset.singleOpen === 'true';

        if (this.singleOpen) {
          this.items.forEach((item) => item.removeAttribute('name'));
        }

        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        this.openFromHash();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get items() {
        return Array.from(this.querySelectorAll(':scope > details.faq-item'));
      }

      get reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      openFromHash() {
        if (!window.location.hash) return;
        let target = null;
        try {
          target = this.querySelector(window.location.hash);
        } catch (error) {
          return;
        }
        const details = target && target.closest('details.faq-item');
        if (details && this.contains(details) && !details.open) {
          this.open(details, { animate: false });
        }
      }

      onClick(event) {
        const summary = event.target.closest('summary.faq-question');
        if (!summary || !this.contains(summary)) return;

        const details = summary.parentElement;
        if (!details || details.tagName !== 'DETAILS') return;

        // Let genuine links inside a question behave like links.
        if (event.target.closest('a[href]')) return;

        event.preventDefault();

        const wrapper = this.wrapperFor(details);
        const isClosing = wrapper ? wrapper.faqClosing === true : false;

        if (details.open && !isClosing) {
          this.close(details);
        } else {
          this.open(details);
        }
      }

      onBlockSelect(event) {
        const details = event.target.closest('details.faq-item');
        if (details && !details.open) this.open(details, { animate: false });
      }

      wrapperFor(details) {
        return details.querySelector(':scope > .faq-answer-wrapper');
      }

      open(details, options) {
        const animate = !options || options.animate !== false;
        const wrapper = this.wrapperFor(details);

        if (this.singleOpen) {
          this.items.forEach((item) => {
            if (item !== details && item.open) this.close(item);
          });
        }

        const from = wrapper && wrapper.faqAnimation ? wrapper.getBoundingClientRect().height : 0;

        details.open = true;

        if (!wrapper) return;

        wrapper.faqClosing = false;

        if (!animate || this.reducedMotion) {
          this.cancel(wrapper);
          wrapper.style.height = '';
          return;
        }

        this.run(wrapper, from, wrapper.scrollHeight, () => {
          // Back to auto, so the panel reflows if the content or viewport changes.
          wrapper.style.height = '';
        });
      }

      close(details) {
        const wrapper = this.wrapperFor(details);

        if (!wrapper || this.reducedMotion) {
          if (wrapper) {
            this.cancel(wrapper);
            wrapper.style.height = '';
            wrapper.faqClosing = false;
          }
          details.open = false;
          return;
        }

        const from = wrapper.getBoundingClientRect().height;
        wrapper.faqClosing = true;

        this.run(wrapper, from, 0, () => {
          wrapper.faqClosing = false;
          wrapper.style.height = '';
          details.open = false;
        });
      }

      cancel(wrapper) {
        if (wrapper.faqAnimation) {
          wrapper.faqAnimation.cancel();
          wrapper.faqAnimation = null;
        }
      }

      run(wrapper, from, to, done) {
        this.cancel(wrapper);

        if (!wrapper.animate) {
          done();
          return;
        }

        wrapper.style.height = from + 'px';

        const animation = wrapper.animate(
          [{ height: from + 'px' }, { height: to + 'px' }],
          { duration: 350, easing: 'cubic-bezier(0.33, 1, 0.68, 1)' }
        );

        wrapper.faqAnimation = animation;

        animation.onfinish = () => {
          wrapper.faqAnimation = null;
          done();
        };

        animation.oncancel = () => {
          wrapper.faqAnimation = null;
        };
      }
    }

    customElements.define('faq-accordion', FaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var OPEN_CLASS = 'is-open';

    function setMaxHeight(content, px) {
      content.style.maxHeight = px + 'px';
    }

    function closeItem(trigger, content) {
      setMaxHeight(content, content.scrollHeight);
      content.offsetHeight;
      trigger.classList.remove(OPEN_CLASS);
      content.classList.remove(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
      requestAnimationFrame(function () {
        setMaxHeight(content, 0);
      });
    }

    function openItem(trigger, content) {
      trigger.classList.add(OPEN_CLASS);
      content.classList.add(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
      setMaxHeight(content, content.scrollHeight);

      function onTransitionEnd(evt) {
        if (evt.target !== content || evt.propertyName !== 'max-height') return;
        content.removeEventListener('transitionend', onTransitionEnd);
        if (content.classList.contains(OPEN_CLASS)) {
          content.style.maxHeight = 'none';
        }
      }
      content.addEventListener('transitionend', onTransitionEnd);
    }

    function getContent(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    function initList(list) {
      if (list.dataset.seasonalFaqBound) return;
      list.dataset.seasonalFaqBound = 'true';

      var triggers = Array.prototype.slice.call(
        list.querySelectorAll('.seasonal-faq__trigger')
      );

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var content = getContent(trigger);
          if (!content) return;

          if (trigger.classList.contains(OPEN_CLASS)) {
            closeItem(trigger, content);
            return;
          }

          triggers.forEach(function (other) {
            if (other !== trigger && other.classList.contains(OPEN_CLASS)) {
              var otherContent = getContent(other);
              if (otherContent) closeItem(other, otherContent);
            }
          });

          openItem(trigger, content);
        });
      });
    }

    document.querySelectorAll('.seasonal-faq__list').forEach(initList);

    document.addEventListener('shopify:section:load', function (event) {
      var list = event.target.querySelector('.seasonal-faq__list');
      if (list) initList(list);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-promotion-challenge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__seasonalPromotionChallengeSliderBound) return;
    window.__seasonalPromotionChallengeSliderBound = true;

    var GRID_SELECTOR = '.seasonal-promotion-challenge__grid';
    var ITEM_SELECTOR = '.seasonal-promotion-challenge__item';
    var drag = null;
    var suppressClickUntil = 0;

    function closestGrid(el) {
      return el && el.closest ? el.closest(GRID_SELECTOR) : null;
    }

    function isScrollable(grid) {
      return grid.scrollWidth > grid.clientWidth + 1;
    }

    document.addEventListener(
      'wheel',
      function (event) {
        var grid = closestGrid(event.target);
        if (!grid || !isScrollable(grid)) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        grid.scrollLeft += event.deltaY;
        event.preventDefault();
      },
      { passive: false }
    );

    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return; // native touch scrolling handles this
      var grid = closestGrid(event.target);
      if (!grid || !isScrollable(grid)) return;
      drag = {
        grid: grid,
        startX: event.clientX,
        startScrollLeft: grid.scrollLeft,
        moved: false
      };
      grid.classList.add('is-dragging');
    });

    document.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var delta = event.clientX - drag.startX;
      if (Math.abs(delta) > 3) drag.moved = true;
      drag.grid.scrollLeft = drag.startScrollLeft - delta;
    });

    function endDrag() {
      if (!drag) return;
      drag.grid.classList.remove('is-dragging');
      if (drag.moved) suppressClickUntil = Date.now() + 50;
      drag = null;
    }

    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);

    // A drag that ends over a link/button shouldn't also fire its click.
    document.addEventListener(
      'click',
      function (event) {
        if (Date.now() < suppressClickUntil && closestGrid(event.target)) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var grid = closestGrid(document.activeElement);
      if (!grid || !isScrollable(grid)) return;
      var card = grid.querySelector(ITEM_SELECTOR);
      var gap = parseFloat(window.getComputedStyle(grid).columnGap) || 0;
      var step = (card ? card.getBoundingClientRect().width : 280) + gap;
      grid.scrollBy({
        left: event.key === 'ArrowLeft' ? -step : step,
        behavior: 'smooth'
      });
      event.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__seasonalReviewsSliderBound) return;
    window.__seasonalReviewsSliderBound = true;

    var GRID_SELECTOR = '.seasonal-reviews__grid';
    var ITEM_SELECTOR = '.seasonal-reviews__card';
    var drag = null;
    var suppressClickUntil = 0;

    function closestGrid(el) {
      return el && el.closest ? el.closest(GRID_SELECTOR) : null;
    }

    function isScrollable(grid) {
      return grid.scrollWidth > grid.clientWidth + 1;
    }

    document.addEventListener(
      'wheel',
      function (event) {
        var grid = closestGrid(event.target);
        if (!grid || !isScrollable(grid)) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        grid.scrollLeft += event.deltaY;
        event.preventDefault();
      },
      { passive: false }
    );

    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return; // native touch scrolling handles this
      var grid = closestGrid(event.target);
      if (!grid || !isScrollable(grid)) return;
      drag = {
        grid: grid,
        startX: event.clientX,
        startScrollLeft: grid.scrollLeft,
        moved: false
      };
      grid.classList.add('is-dragging');
    });

    document.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var delta = event.clientX - drag.startX;
      if (Math.abs(delta) > 3) drag.moved = true;
      drag.grid.scrollLeft = drag.startScrollLeft - delta;
    });

    function endDrag() {
      if (!drag) return;
      drag.grid.classList.remove('is-dragging');
      if (drag.moved) suppressClickUntil = Date.now() + 50;
      drag = null;
    }

    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);

    // A drag that ends over a link/button shouldn't also fire its click.
    document.addEventListener(
      'click',
      function (event) {
        if (Date.now() < suppressClickUntil && closestGrid(event.target)) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var grid = closestGrid(document.activeElement);
      if (!grid || !isScrollable(grid)) return;
      var card = grid.querySelector(ITEM_SELECTOR);
      var gap = parseFloat(window.getComputedStyle(grid).columnGap) || 0;
      var step = (card ? card.getBoundingClientRect().width : 280) + gap;
      grid.scrollBy({
        left: event.key === 'ArrowLeft' ? -step : step,
        behavior: 'smooth'
      });
      event.preventDefault();
    });
  })();

  (function () {
    if (window.__seasonalReviewsLightboxBound) return;
    window.__seasonalReviewsLightboxBound = true;

    var TRIGGER_SELECTOR = '.seasonal-reviews__photo-trigger';
    var LIGHTBOX_SELECTOR = '.seasonal-reviews__lightbox';
    var CLOSE_SELECTOR = '[data-seasonal-reviews-lightbox-close]';
    var lastTrigger = null;

    function openLightbox(trigger) {
      var section = trigger.closest('.seasonal-reviews');
      var lightbox = section && section.querySelector(LIGHTBOX_SELECTOR);
      var src = trigger.getAttribute('data-full-src');
      if (!lightbox || !src) return;
      var img = lightbox.querySelector('.seasonal-reviews__lightbox-image');
      if (img) {
        img.setAttribute('src', src);
        img.setAttribute('alt', trigger.getAttribute('data-full-alt') || '');
      }
      lightbox.removeAttribute('hidden');
      lastTrigger = trigger;
      var closeButton = lightbox.querySelector('.seasonal-reviews__lightbox-close');
      if (closeButton) closeButton.focus();
    }

    function closeLightbox(lightbox) {
      if (!lightbox || lightbox.hasAttribute('hidden')) return;
      lightbox.setAttribute('hidden', '');
      var img = lightbox.querySelector('.seasonal-reviews__lightbox-image');
      if (img) {
        img.setAttribute('src', '');
        img.setAttribute('alt', '');
      }
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest(TRIGGER_SELECTOR) : null;
      if (trigger) {
        openLightbox(trigger);
        return;
      }

      var closeHit = event.target.closest ? event.target.closest(CLOSE_SELECTOR) : null;
      if (closeHit) {
        closeLightbox(closeHit.closest(LIGHTBOX_SELECTOR));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openLightboxEl = document.querySelector(LIGHTBOX_SELECTOR + ':not([hidden])');
      if (openLightboxEl) closeLightbox(openLightboxEl);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
